import { useEffect, useRef, useState } from "react";

import Helpers from "../../commons/helpers";
import DiscussionService from "../../services/message/DiscussionService";
import UserReactionService from "../../services/message/UserReactionService";

import { showAlert } from "../../providers/AlertProvider";
import { DiscussionGroupType } from "../../constants/enums";
import { useCommentContext } from "../../providers/CommentProvider";
import { IDataComment, IUserComment } from "../../commons/interfaces";
import ReactionService from "../../services/message/ReactionService";

interface IProps {
    threadId?: string;
    requestLevel: number;
    discussionGroupType: DiscussionGroupType;
}

export interface IPageData {
    totalCount: number;
    totalPages: number;
    currentPage: number;
}

const useComment = ({ requestLevel, discussionGroupType, threadId }: IProps) => {
    const listCommentRef = useRef<any[]>([]);

    const { referenceId, userLogin, clientId, organizationId } = useCommentContext();

    const [listComments, setListComments] = useState<IDataComment[]>([]);

    const [pageData, setPageData] = useState<IPageData>({
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
    });

    // useEffect(() => {
    //     getListComment();
    // }, []);

    const getListComment = async (readMore?: boolean) => {
        try {
            let endIn = requestLevel - 1; //cmt cấp đầu tiên = số cấp muốn hiện thị - cấp muốn lấy(ở đây muốn lấy cấp đầu)

            const result = await DiscussionService.getPaged({
                endIn,
                referenceId,
                threadId: threadId,
                type: discussionGroupType,
                pageNumber: readMore ? pageData.currentPage + 1 : pageData.currentPage,
            });

            let tempListComments: IDataComment[] = [...listCommentRef.current] || [];

            (result?.items || []).forEach((e: any) => {
                let userComment: IUserComment = {
                    avatarUrl: e.avatarUrl,
                    fullName: e.fullName,
                    userId: e.userId,
                    userName: e.userName,
                };
                tempListComments.push({
                    channelId: e.channelId,
                    id: e.id,
                    discussionValue: e.discussionValue,
                    threadId: e.threadId,
                    totalReply: e.totalReply,
                    totalReact: e?.totalReact || 0,
                    userReactions: e?.userReactions || [],
                    userComment,
                    timeComment: e.createTime,
                    threadGene: e.threadGene,
                    rating: e.rating,
                    listRepliesToComment: [],
                });
            });

            setPageData({
                totalCount: result?.totalCount,
                currentPage: result?.currentPage,
                totalPages: result?.totalPages,
            });

            let listCommentResult = Helpers.unique(tempListComments);

            listCommentRef.current = listCommentResult;

            setListComments(listCommentResult);
        } catch (error) {
            showAlert(Helpers.renderExceptionError(error), "error");
        }
    };

    const getAllReactionIcon = async () => {
        try {
            const result = await ReactionService.getAll();
            return result;
        } catch (error) {
            return [];
        }
    };

    const handleUnReaction = async (id: string) => {
        const result = await UserReactionService.unReacted({ id });

        let listCommentTemp = [...listCommentRef.current];

        const index = listCommentTemp.findIndex((e) => e.id === result.targetId);

        listCommentTemp[index].userReactions = listCommentTemp[index].userReactions?.filter((el: any) => el.id !== result.id);

        listCommentRef.current = listCommentTemp;
        setListComments(listCommentTemp || []);
    };

    const handleReaction = async (targetId: string, reactionCode: number) => {
        const data = {
            clientId,
            reactionCode,
            organizationId,
            userId: userLogin?.userId || "",
            targetType: discussionGroupType,
            targetId,
        };
        const result = await UserReactionService.reaction(data);

        let listCommentTemp = [...listCommentRef.current];

        const index = listCommentTemp.findIndex((e) => e.id === targetId);

        if (Helpers.isNullOrEmpty(listCommentTemp[index].userReactions)) {
            listCommentTemp[index] = Object.assign(listCommentTemp[index], { userReactions: [result] });
        } else {
            listCommentTemp[index].userReactions = [...listCommentTemp[index]?.userReactions, result];
        }

        listCommentRef.current = listCommentTemp;
        setListComments(listCommentTemp || []);
    };

    const handleHideComment = (gene: string) => {
        let listCommentTemp = listCommentRef.current?.filter(
            (e) => e.threadGene.length <= gene.length && !(e.threadGene.startsWith(gene) && e.threadGene !== gene)
        );
        listCommentRef.current = listCommentTemp;
        setListComments(listCommentTemp);
    };

    const onViewReplyComment = async (replyTo: string, level: number, index: number, pageNumber?: number, isReadMore?: boolean) => {
        const endIn = requestLevel - level; //cmt cấp đầu tiên = số cấp muốn hiện thị - cấp muốn lấy(ở đây muốn lấy cấp đầu);
        const result = await DiscussionService.getPaged({
            endIn,
            replyTo,
            referenceId,
            threadId: threadId,
            type: discussionGroupType,
            pageNumber: pageNumber || 1,
        });

        let tempListComments: IDataComment[] = [...listCommentRef.current] || [];
        let listRepliesToComment: IDataComment[] = [];

        (result?.items || []).forEach((e: any) => {
            let userComment: IUserComment = {
                avatarUrl: e.avatarUrl,
                fullName: e.fullName,
                userId: e.userId,
                userName: e.userName,
            };
            listRepliesToComment.push({
                channelId: e.channelId,
                id: e.id,
                discussionValue: e.discussionValue,
                threadId: e.threadId,
                totalReply: e.totalReply,
                totalReact: e?.totalReact || 0,
                userReactions: e?.userReactions || [],
                userComment,
                timeComment: e.createTime,
                threadGene: e.threadGene,
            });
        });
        if (isReadMore) {
            tempListComments.splice(
                index + 1 + (tempListComments[index]?.currentPage || 0) * (tempListComments[index]?.pageSize || 0),
                0,
                ...listRepliesToComment
            );
        } else {
            tempListComments.splice(index + 1, 0, ...listRepliesToComment);
        }

        tempListComments[index].currentPage = result?.currentPage;
        tempListComments[index].totalPages = result?.totalPages;
        tempListComments[index].pageSize = result?.pageSize;

        let listCommentResult = Helpers.unique(tempListComments);
        listCommentRef.current = listCommentResult;
        setListComments(listCommentResult);
    };

    const deleteComment = async (messageId: string) => {
        try {
            await DiscussionService.delete({ id: messageId, userId: userLogin?.userId });

            const tempListComments = [...listComments || []].filter(item => item.id !== messageId);

            const listCommentResult = Helpers.unique(tempListComments);

            listCommentRef.current = listCommentResult;

            setListComments(listCommentResult);

            return tempListComments;
        } catch (error) {
            showAlert(Helpers.renderExceptionError(error), "error");
        }
    };

    const createComment = async (data: {
        channelId: string,
        message: string,
        replyTo?: string
    }) => {
        try {
            const result = await DiscussionService.create({
                userId: userLogin?.userId,
                channelId: data.channelId,
                replyTo: data.replyTo,
                threadId: threadId,
                discussionValue: data.message,
            });

            const tempListComments = [...listComments || []];

            const indexReplyTo = tempListComments.findIndex(item => item.id === data.replyTo);

            if (indexReplyTo !== -1) {
                const itemTemp = { ...tempListComments[indexReplyTo] };
                tempListComments[indexReplyTo] = {
                    ...itemTemp,
                    totalReply: itemTemp?.totalReply + 1,
                };
            }

            const itemTemp: IDataComment = {
                id: result[0].id,
                channelId: result[0].channelId,
                threadId: result[0].threadId,
                threadGene: result[0].threadGene,
                timeComment: result[0].updateTime,
                discussionValue: result[0].discussionValue,
                totalReply: result[0].totalReply,
                replyTo: result[0].replyTo,
                rating: result[0].rating,
                userComment: {
                    userId: result[0].userId,
                    avatarUrl: result[0].avatarUrl,
                    fullName: result[0].fullName,
                    userName: result[0].userName,
                },
                userReactions: undefined,
                listRepliesToComment: undefined,
            };

            tempListComments.splice(indexReplyTo + 1, 0, itemTemp);

            const listCommentResult = Helpers.unique(tempListComments);

            listCommentRef.current = listCommentResult;

            setListComments(listCommentResult);

            return tempListComments;
        } catch (error) {
            showAlert(Helpers.renderExceptionError(error), "error");
        }
    };

    const updateComment = async (data: {
        message: string,
        messageId?: string
    }) => {
        try {
            const result = await DiscussionService.update({
                id: data.messageId,
                userId: userLogin?.userId,
                discussionValue: data.message,
            });

            let tempListComments = [...listComments || []];

            const indexTemp = [...listComments || []].findIndex(item => item.id === data?.messageId);

            if (indexTemp !== -1) {
                tempListComments[indexTemp] = {
                    ...tempListComments[indexTemp],
                    timeComment: result.updateTime,
                    discussionValue: result.discussionValue,
                };

                const listCommentResult = Helpers.unique(tempListComments);

                listCommentRef.current = listCommentResult;

                setListComments(listCommentResult);
            }

            return tempListComments;
        } catch (error) {
            showAlert(Helpers.renderExceptionError(error), "error");
        }
    };

    return {
        listCommentRef,
        listComments,
        pageData,
        getListComment,
        getAllReactionIcon,
        setPageData,
        setListComments,
        onViewReplyComment,
        handleReaction,
        handleUnReaction,
        handleHideComment,
        deleteComment,
        createComment,
        updateComment,
    };
};
export default useComment;
